import { LinkType, Prismic, PrismicContext } from '@landsbankinn/prismic';
import { parseISO } from 'date-fns';
import React, { useContext } from 'react';
import { CardNewsGroup } from '../components/card-group/CardNewsGroup';
import { NewsCard } from '../components/card/NewsCard';

interface IProps {
  heading: Prismic.RichText;
  heading_link: Prismic.Link;
  featured: boolean;
  articles: boolean;
  fields: IField[];
  items: any;
}

interface IField {
  article?: IArticle;
  article_abstract: Prismic.RichText;
}

interface IArticle {
  _meta: any;
  title: Prismic.RichText;
  abstract: Prismic.RichText;
  date: string;
}

export const NewsCardsContainer = ({
  heading,
  featured,
  heading_link,
  fields,
}: IProps) => {
  const { urlResolver } = useContext(PrismicContext);
  const headingLink = Prismic.link(urlResolver, heading_link);
  return (
    <CardNewsGroup
      heading={Prismic.text(heading)}
      link={headingLink.as}
      featured={featured}
      length={Math.min(4, fields.length)}
    >
      {fields?.slice(0, 4).map((item: IField, index: number) => {
        if (!item.article) {
          return null;
        }
        const link = Prismic.link(
          urlResolver,
          {
            _linkType: LinkType.Document,
            ...item?.article,
          },
          item?.article?.title,
        );
        return (
          <NewsCard
            key={index}
            link={link}
            date={parseISO(item?.article?.date)}
            title={link.title}
            description={
              item?.article_abstract &&
              Prismic.text(item?.article_abstract) !== ''
                ? Prismic.text(item?.article_abstract)
                : Prismic.text(item?.article?.abstract)
            }
          />
        );
      })}
    </CardNewsGroup>
  );
};
